module.exports = __webpack_public_path__ + "static/media/landing-animation-4.9da974fb.gif";